import React from 'react'
import { Divider } from 'antd'
import { withTranslation } from 'react-i18next'
import BranchInfo from '../../login/branchInfo'

const DefaultFooter = ({ t, isMobile }) => {
  const currentYear = new Date().getFullYear()

  const branches = [
    {
      id: 1,
      name: t('branch1-name'),
      address: t('branch1-address'),
      phone: t('branch1-phone'),
      email: t('branch1-email'),
    },
    {
      id: 2,
      name: t('branch2-name'),
      address: t('branch2-address'),
      phone: t('branch2-phone'),
      email: t('branch2-email'),
    },
    {
      id: 3,
      name: t('branch3-name'),
      address: t('branch3-address'),
      phone: t('branch3-phone'),
      email: t('branch3-email'),
    },
  ]

  return (
    <div className='default-footer'>
      <div className='footer-branch-container'>
        {!isMobile &&
          branches.map((branch, index) => (
            <React.Fragment key={branch.id}>
              <BranchInfo key={branch.id} {...branch} />
              {index < branches.length - 1 && (
                <Divider type='vertical' className='footer-divider' />
              )}
            </React.Fragment>
          ))}
      </div>
      <div className='footer-url'>
        <a href='http://www.iturria.com.ar/'>Iturria</a>
        <span> - </span>
        <span>{`${t('footer-text')} ${currentYear}`}</span>
      </div>
    </div>
  )
}

export default withTranslation()(DefaultFooter)
